import { Typography } from '@mui/material';
import Flex from 'legacyfrontend/components/Flex';
import { HiOutlineLocationMarker, HiOutlineMail, HiOutlinePhone } from 'react-icons/hi';
import { useSelector } from 'react-redux';
import { selectGeoData } from 'legacyfrontend/redux/selectors/application-selectors';

export default function AgencyCardContent({ agency }) {
  const { geo } = useSelector(selectGeoData);

  const getAgencyLocationData = (agency) => {
    if (!geo) return;
    const { localities } = geo;
    const filteredLocality = localities.data.find((locality) => locality.id === agency.localidadId);
    return filteredLocality;
  };

  const getAgencyLocation = (agency) => {
    const location = getAgencyLocationData(agency);

    const address = agency.direccion ? `${agency.direccion}` : '';
    const name = location?.nombre ? `, ${location?.nombre}` : '';
    const province = location?.provincia?.nombre ? `, ${location?.provincia.nombre}` : '';
    const country = location?.provincia?.pais?.nombre ? `, ${location?.provincia.pais.nombre}` : '';

    return `${address} ${name} ${province} ${country}`.trim();
  };

  return (
    <Flex className='agencies__card__content' vertical>
      <div className='agencies__card__header'>
        <Typography component='div' variant='h6'>
          {agency.nombre}
        </Typography>
      </div>
      <Flex className='agencies__card__row'>
        <HiOutlineMail className='agency__card__icon' size={24} />
        <div className='agency__card__content__text'>
          <Typography component='div' variant='body2'>
            {agency.email}
          </Typography>
        </div>
      </Flex>
      <Flex className='agencies__card__row'>
        <HiOutlineLocationMarker className='agency__card__icon' size={24} />
        <div className='agency__card__content__text'>
          <Typography component='div' variant='body2'>
            {getAgencyLocation(agency)}
          </Typography>
        </div>
      </Flex>
      <Flex className='agencies__card__row'>
        <HiOutlinePhone className='agency__card__icon' size={24} />
        <div className='agency__card__content__text'>
          <Typography component='div' variant='body2'>
            {agency.telefono}
          </Typography>
        </div>
      </Flex>
    </Flex>
  );
}
